import FieldDefs from './DomainsFieldDefs'
import GroupDomainsAction from '../../../component/ks-table/component/group-domains-action.vue'
import {doLangFields} from '../../../lib/ks-tools'
import {Listeners} from "../../../constants/listeners";

export default {
    template: `<div><slot v-bind="self"/></div>`,
    props: ["isDemo"],
    data() {
        return {
            fields: this.getTableFields(),
            sortOrder: [
                {
                    field: 'it50',
                    direction: 'desc'
                }
            ],
            moreParams: {},
            viewMode: 0,
            options: [
                {label: this.$t('lang.group_report.organic'), value: 0},
                {label: this.$t('lang.group_report.context'), value: 1},
            ]
        }
    },
    mounted() {
        this.initFields();
    },
    computed: {
        self() {
            return this;
        },
    },
    methods: {
        getTableFields() {
            let fields = doLangFields(this, "lang.group_report.domains", FieldDefs);
            if (this.isDemo){
                fields.shift();
            }

            return fields;
        },
        initFields() {
            let self = this;
            self.fields.forEach((f) => {
                if (f.hasOwnProperty('visibleRule')) {
                    f.visible = eval(f.visibleRule);
                }
            });
            this.$emitter.emit(Listeners.KS_TABLE_NORMALIZE_FIELDS);
        }
    },
    watch: {
        viewMode: function(val) {
            this.initFields();
        }
    },
    components: {
        GroupDomainsAction,
    },
}
